import { render, staticRenderFns } from "./ResvCalendar.vue?vue&type=template&id=bd38f650&scoped=true"
import script from "./ResvCalendar.vue?vue&type=script&lang=js"
export * from "./ResvCalendar.vue?vue&type=script&lang=js"
import style0 from "./ResvCalendar.vue?vue&type=style&index=0&id=bd38f650&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd38f650",
  null
  
)

export default component.exports